<template>
  <!-- Clients-->
  <div class="py-5 bg-light">
    <div class="container">
      <div class="row align-items-center">
        <div class="">
          <div class="jumbotron">
            <h1 class="display-2 text-uppercase">Nos partenaires</h1>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 my-3">
          <a
            href="https://www.nike.com/fr/w/promotions-3yaep?CP=EUNS_AFF_AWIN_FR_331635_httpwwwtwittercomcaminotv_555099&utm_source=httpwwwtwittercomcaminotv&utm_medium=affiliate&utm_campaign=331635&utm_content=555099&awc=16328_1663674366_0f4c2ad563cd329169893c692244516e"
            target="_blank"
            ><img
              class="img-fluid img-brand d-block mx-auto"
              src="../assets/img/logo/nike-removebg-preview.png"
              alt="..."
          /></a>
        </div>
        <div class="col-md-3 col-sm-6 my-3">
          <a href="https://www.nike.com/fr/w/jordan-37eef?cp=24158993452_search_%7cjordan%20com%7c10690196375%7c109471848470%7ce%7cc%7cFR%7cstyles%7c452608683275&ds_rl=1252249&gclid=Cj0KCQjwyt-ZBhCNARIsAKH11757eCPIyWZOIi6Mwuu7T3D1xBkcc82mm03g7k90iacp5P4vJ7DS8KAaAltQEALw_wcB&gclsrc=aw.ds" target="_blank"
            ><img
              class="img-fluid img-brand d-block mx-auto"
              src="../assets/img/logo/jojo-removebg-preview.png"
              alt="..."
          /></a>
        </div>
        <div class="col-md-3 col-sm-6 my-3">
          <a href="https://www.supremenewyork.com/" target="_blank"
            ><img
              class="img-fluid img-brand d-block mx-auto"
              src="../assets/img/logo/sup-removebg-preview.png"
              alt="..."
          /></a>
        </div>
        <div class="col-md-3 col-sm-6 my-3">
          <a href="https://eu.puma.com/fr/fr/home?gclid=Cj0KCQjwyt-ZBhCNARIsAKH1176GSbK4K1UGzCpRa9vcJCf6y6U-6FYPqxva9uqo7MuHLgVlH55YLg0aAqMBEALw_wcB" target="_blank"
            ><img
              class="img-fluid img-brand d-block mx-auto"
              src="../assets/img/logo/puma-removebg-preview.png"
              alt="..."
          /></a>
        </div>
      </div>
    </div>
  </div>
  <footer class="footer py-4">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-4 text-lg-start">
          Copyright &copy; SneakersAddict.com 2022
        </div>
        <div class="col-lg-4 my-3 my-lg-0">
          <a class="btn btn-dark btn-social mx-2" 
            ><i class="fab fa-twitter"></i
          ></a>
          <a class="btn btn-dark btn-social mx-2" 
            ><i class="fab fa-facebook-f"></i
          ></a>
          <a class="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/elimflorvil/"
            ><i class="fab fa-linkedin-in"></i
          ></a>
        </div>
        <div class="col-lg-4 text-lg-end">
          <a class="link-dark text-decoration-none me-3" 
            >Privacy Policy</a
          >
          <a class="link-dark text-decoration-none" >Terms of Use</a>
        </div>
      </div>
    </div>
  </footer>
</template>
